import React from 'react'

import PageTransition from './templateParts/PageTransition'

export default function SingleProject() {
  return (
    <PageTransition>
      <div>SingleProject</div>
    </PageTransition>
  )
}
